import React from 'react';
import { motion } from 'framer-motion';
import './Media.css';

interface Article {
  url: string;
  title?: string;
  image?: string;
  source?: string;
  date?: string;
  description?: string;
}

const Media: React.FC = () => {
  /**
   * Media articles array
   * 
   * You can manually add title, image, description, source, and date for each article.
   * Alternatively, you can fetch this data from an API endpoint.
   * 
   * Example API integration:
   * const [articles, setArticles] = useState<Article[]>([]);
   * useEffect(() => {
   *   fetch('/api/articles')
   *     .then(res => res.json())
   *     .then(data => setArticles(data));
   * }, []);
   */
  const articles: Article[] = [
    {
      url: 'https://www.ratopati.com/story/504021/carrying-on-bindus-legacy-saugat-launches-resort-with-investment-of-rs-700-million',
      title: 'विन्दुको विरासत धान्दै सौगात, ७० करोडको लगानीमा रिसोर्ट',
      image: 'https://npcdn.ratopati.com/media/news/00_mwPYe2tQrd.jpg',
      source: 'Ratopati',
      date: '2025-07-31'
    },
    {
      url: 'https://baahrakhari.com/detail/458402',
      title: 'पोखरामा बगैँचा : स्पा, साउन्ड थेरापी र आत्मिक विश्रामको थलो',
      image: 'https://baahrakhari.com/uploads/posts/bagaicha-(1)-1753436896.jpeg',
      source: 'Baahrakhari',
      date: '2025-07-25'
    },
    {
      url: 'https://www.nayapatrikadaily.com/news-details/157104/2025-01-03',
      title: 'उद्यममा उदीयमान पुस्ता',
      image: 'https://nayapatrika.fsn1.your-objectstorage.com/news/images/udhyami-gen-z2025-01-03-05-02-28.jpeg',
      source: 'Naya Patrika',
      date: '2025-01-03'
    },
    {
      url: 'https://english.gandaknews.com/2024/09/15/139916/',
      title: 'Young leadership in choice, Saugat wins with respectable votes',
      image: 'https://english.gandaknews.com/wp-content/uploads/2024/09/saugat-thapa-3-e1726414119243-1024x611.jpg',
      source: 'Gandak News',
      date: '2024-09-15'
    },
    {
      url: 'https://english.gandaknews.com/2024/09/07/139897/',
      title: '‘Youth in slogans many times, Youth in leadership this time’ – Saugat Thapa',
      image: 'https://english.gandaknews.com/wp-content/uploads/2024/09/saugat-speech.jpg',
      source: 'Gandak News',
      date: '2024-09-07'
    },
    {
      url: 'https://ekagaj.com/news/detail/178452/',
      title: 'बुवाकै पथमा हिँडिरहेका सौगात नयाँ पुस्ताका लागि उदाहरण बन्‍ने लयमा',
      image: 'https://ekagajcdn.prixacdn.net/media/albums/saugat_dx1831NC7n.jpg',
      source: 'Ekagaj',
      date: '2024-08-29'
    },
    {
      url: 'https://www.setopati.com/kinmel/tourism/337676',
      title: 'अंशुभराको लेकसाइडमा "३१ एभिन्यु" आउँदै',
      image: 'https://www.setopati.com/uploads/posts/Untitled-1724747985.jpg',
      source: 'Setopati',
      date: '2024-08-27'
    },
    {
      url: 'https://parichaya.com/saugat-thapa-news/',
      title: 'पोखरा ट्रेडमलको बोर्ड अफ डाइरेक्टरमा सौगात थापा नियुक्त',
      image: 'https://parichaya.com/wp-content/uploads/2023/10/thumnaill.jpg',
      source: 'Parichaya',
      date: '2023-08-07'
    },
    {
      url: 'https://baahrakhari.com/detail/328348',
      title: 'अंशुभराको प्रायोजनमा मैदान उत्रिँदै पोखराको "स्पोर्ट्स क्यासल"',
      image: 'https://baahrakhari.com/uploads/posts/Footsall1631456378.jpg',
      source: 'Baahrakhari',
      date: '2021-09-12'
    }
  ];

  // Extract domain name from URL for source if not provided
  const getSourceFromUrl = (url: string): string => {
    try {
      const urlObj = new URL(url);
      const hostname = urlObj.hostname.replace('www.', '');
      // Capitalize first letter
      return hostname.split('.')[0].charAt(0).toUpperCase() + hostname.split('.')[0].slice(1);
    } catch {
      return 'External';
    }
  };

  // Format date for display
  const formatDate = (dateString?: string): string => {
    if (!dateString) return '';
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
    } catch {
      return dateString;
    }
  };

  return (
    <div className="venture-page">
      <div className="venture-container">
        {/* Main Content */}
        <div className="venture-content">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="venture-main-section"
          >
            <div className="venture-header">
              <div className="venture-header-background"
                style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/agriculture.jpg)` }}
              >
                <div className="venture-header-overlay">
                  <h2 className="section-main-title">Media</h2>
                </div>
              </div>
            </div>

            {/* Articles Grid Section */}
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              viewport={{ once: true }}
              className="media-articles-section"
            >
              <div className="media-articles-container">
                <div className="media-articles-grid">
                  {articles.map((article, index) => (
                    <motion.div
                      key={index}
                      initial={{ opacity: 0, y: 30 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.5, delay: index * 0.1 }}
                      viewport={{ once: true }}
                      whileHover={{ y: -5 }}
                      className="media-article-card"
                    >
                      <a
                        href={article.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="media-article-link"
                      >
                        {article.image && (
                          <div className="media-article-image">
                            <div
                              className="media-article-image-bg"
                              style={{ backgroundImage: `url(${article.image})` }}
                              onError={(e) => {
                                // Hide image if it fails to load
                                e.currentTarget.style.display = 'none';
                              }}
                            ></div>
                          </div>
                        )}
                        <div className="media-article-content">
                          <div className="media-article-source">
                            {article.source || getSourceFromUrl(article.url)}
                          </div>
                          <h3 className="media-article-title">
                            {article.title || 'Read Full Article'}
                          </h3>
                          {article.description && (
                            <p className="media-article-description">{article.description}</p>
                          )}
                          {article.date && (
                            <div className="media-article-date">{formatDate(article.date)}</div>
                          )}
                        </div>
                      </a>
                    </motion.div>
                  ))}
                </div>
              </div>
            </motion.div>

          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default Media;

